/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.5",
    versionName: "0.2.0-nightly.2026.5.5",
    versionChannel: "nightly",
    buildDate: "2026-05-05T00:22:34.618Z",
    commitHash: "307863eeb5f8760007ec5685007b8e419e6bfd5e",
};
